export const DIFFS_ENDPOINT = "/reports/v1/diff";
export const REPORTS_ENDPOINT = "/reports/v1/report";
//# sourceMappingURL=endpoints.js.map